// TGW-1510: 楽観UI の状態遷移を純粋ロジックとして切り出し（DM/サークル/イベントで共用）。
// 設計詳細は tasks/TGW-1510.md §2.3 を参照。

export const WS_ACK_TIMEOUT_MS = 30000;

// HTTP 失敗を「確定的クライアントエラー」か「曖昧喪失」かに分類する。
//   4xx                            → 'failed'      （送信失敗・再送可）
//   0(ネットワーク断) / 5xx / その他 → 'unconfirmed'（曖昧。サーバー側コミット済の可能性）
export function classifyAjaxFailure(jqXHR) {
  const status = jqXHR && typeof jqXHR.status === 'number' ? jqXHR.status : 0;
  return status >= 400 && status < 500 ? 'failed' : 'unconfirmed';
}

// clientId のメッセージを指定 status に更新した新配列を返す。
export function setMessageStatus(messages, clientId, status) {
  return messages.map((m) => (m.client_id === clientId ? { ...m, status } : m));
}

// WS message_created 受信時のマージ（楽観の置換 / 重複追加防止）。
export function applyIncomingMessage(messages, incoming, clientId) {
  const next = [...messages];
  if (clientId) {
    const idx = next.findIndex((m) => m.client_id === clientId);
    if (idx >= 0) {
      next[idx] = { ...incoming, status: 'sent' };
      return next;
    }
  }
  if (!next.find((m) => m.id === incoming.id)) {
    next.push({ ...incoming, status: 'sent' });
  }
  return next;
}

// 失敗タイマーのレジストリ（clientId 単位で arm / clear）。
export function createPendingTimeouts() {
  const map = new Map();
  return {
    arm(clientId, onTimeout, delay = WS_ACK_TIMEOUT_MS) {
      this.clear(clientId);
      map.set(
        clientId,
        setTimeout(() => {
          map.delete(clientId);
          onTimeout();
        }, delay),
      );
    },
    clear(clientId) {
      const id = map.get(clientId);
      if (id) {
        clearTimeout(id);
        map.delete(clientId);
      }
    },
    clearAll() {
      map.forEach((id) => clearTimeout(id));
      map.clear();
    },
  };
}
